// Shared utilities for Admin components

export const TACO_MASCOT_URL = "https://customer-assets.emergentagent.com/job_ttouchmanage/artifacts/sua7mu0g_Untitled%20design%20%288%29.png";

export const getRoleBadge = (role) => {
  const colors = {
    director: 'bg-purple-50 text-purple-700',
    manager: 'bg-blue-50 text-blue-700',
    staff: 'bg-zinc-100 text-zinc-700',
  };
  return colors[role] || 'bg-zinc-100 text-zinc-700';
};

export const getCategoryBadgeColor = (category) => {
  const colors = {
    cleaning_tips: 'bg-emerald-50 text-emerald-700',
    app_features: 'bg-blue-50 text-blue-700',
    operations: 'bg-purple-50 text-purple-700',
    safety: 'bg-red-50 text-red-700',
    procedures: 'bg-amber-50 text-amber-700',
    faq: 'bg-cyan-50 text-cyan-700',
    preferences: 'bg-pink-50 text-pink-700',
  };
  return colors[category] || 'bg-zinc-100 text-zinc-700';
};

export const getVisibilityBadgeColor = (visibility) => {
  const colors = {
    staff: 'bg-zinc-100 text-zinc-700',
    manager: 'bg-blue-50 text-blue-700',
    director: 'bg-purple-50 text-purple-700',
  };
  return colors[visibility] || 'bg-zinc-100 text-zinc-700';
};

export const formatCategory = (category) => {
  return category?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || category;
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(price);
};

export const getPricingModelLabel = (model) => {
  switch (model) {
    case 'flat': return 'Flat Price';
    case 'variant': return 'Variant (Crew Options)';
    case 'matrix': return 'Matrix (Bed/Bath/Story)';
    default: return model;
  }
};
